module.exports = __webpack_public_path__ + "static/img/5.7a2a604.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/5.png
// module id = e2Es
// module chunks = 0